import {i18n} from '@yourcoach/i18n';

import type {AlertButton} from '../../../components/alert/components/Alert/types';
import type {ThemeColor} from '../../../styles/theme';
import type {Button} from '../../../uikit/Button';
import type {GetComponentProps} from '../../../utils/utility-types';

import RecordIcon from '../../../assets/icons/primary/Record.svg';
import {alert} from '../../../components/alert';
import {envManager} from '../../../utils/env';

export type ShowRecordConfirmParams = {
  declineMode: 'disconnect' | 'do_not_record';
  onAllow: () => void;
  onDecline: () => void;
  onShow: () => void;
  titleKey: 'quality_assurance' | 'regular';
};

export const showRecordConfirm = ({
  declineMode = 'disconnect',
  onAllow,
  onDecline,
  onShow,
  titleKey = 'regular',
}: ShowRecordConfirmParams) => {
  onShow();

  const {allowButtonScheme, iconColor} = getColors();

  alert.show({
    buttons: [
      {
        label: i18n.t('shared:ok'),
        onClick: onAllow,
        scheme: allowButtonScheme,
      },
      {
        label:
          /**
           * @i18n_parser
           * t('shared:disconnect')
           * t('shared:do_not_record')
           */
          i18n.t(`shared:${declineMode}`),
        onClick: onDecline,
      },
    ],
    icon: RecordIcon,
    iconColor,
    title:
      /**
       * @i18n_parser
       * t('shared:Conference.recording_confirm.quality_assurance')
       * t('shared:Conference.recording_confirm.regular')
       */
      i18n.t(`shared:Conference.recording_confirm.${titleKey}`),
    variant: 'promo',
  });
};

function getColors(): {
  allowButtonScheme: AlertButton['scheme'];
  iconColor: ThemeColor;
} {
  const iconColor: ThemeColor = envManager.isB2bWidget ? 'global1' : 'global2';
  const allowButtonScheme: GetComponentProps<typeof Button>['scheme'] =
    envManager.isB2bWidget ? 'primary' : 'secondary';

  return {allowButtonScheme, iconColor};
}
